const resetOptions = options => {
  const newOptions = {};

  for (let key in options) {
    newOptions[key] = null;
  }

  return newOptions;
};

const sanitizeSpaces = str => str.replace(/\s{1,}/g, ' ');

const classHandler = (objValue, srcValue, key) => {
  let classes = undefined;
    
  if (key === 'customClasses') {
    classes = srcValue;
    
    if (typeof objValue === 'string') {
      const classExists = objValue.indexOf(srcValue) !== -1;

      classes = classExists ?
        objValue.replace(srcValue, '') :
        `${objValue} ${srcValue}`;

      classes = sanitizeSpaces(classes);
    }
  } 

  return classes;
};

export { resetOptions, sanitizeSpaces, classHandler };


// WEBPACK FOOTER //
// ./src/components/ShowCase/utils.js